import React, { useState } from 'react';
import StepComponent from 'components/StepComponent/CustomSteps';
import { getStepsReport99 } from 'constants/inventorySteps';
import { useTranslation } from 'react-i18next';

const Report99Steps: React.FC = () => {
  const { t } = useTranslation();
  const stepsReport99 = getStepsReport99(t);
  const [current, setCurrent] = useState(0);
  const title = stepsReport99[current]?.title;

  return (
    <StepComponent
      steps={stepsReport99}
      current={current}
      onStepChange={setCurrent}
      title={title}
    />
  );
};

export default Report99Steps;
